import React from 'react';
import { Menu } from 'antd';
import PropTypes from 'prop-types';
import './RDMenu.scss';

const RDMenu = ({ selectedOption, handleMenu, menuItems, mode, style }) => (
  <Menu onClick={handleMenu} selectedKeys={[selectedOption]} mode={mode} style={style}>
    {menuItems.map(({ key, value, disabled, icon, required, menuStyle }) => (
      <Menu.Item disabled={disabled} key={key} icon={icon} style={menuStyle}>
        {required ? (
          <>
            {value} <span className="required-tab-icon"> * </span>
          </>
        ) : (
          value
        )}
      </Menu.Item>
    ))}
  </Menu>
);

RDMenu.defaultProps = {
  handleMenu: () => {},
  mode: 'horizontal',
  selectedOption: '',
  style: {},
};

RDMenu.propTypes = {
  /** Currently selected menu item */
  selectedOption: PropTypes.string,
  /** Called when a menu item is clicked */
  handleMenu: PropTypes.func,
  /** Menu items */
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      disabled: PropTypes.bool,
      icon: PropTypes.element,
      required: PropTypes.bool,
      menuStyle: PropTypes.shape({}),
    }),
  ).isRequired,
  /** Style of the root node */
  style: PropTypes.shape({}),
  /** Type of menu */
  mode: PropTypes.oneOf(['horizontal', 'vertical']),
};

export default RDMenu;
